export const getStatusColor = (status: string) => {
    switch (status) {
      case 'COMPLETED':
        return '#1DA316'; 
      case 'CANCELLED':
        return '#DC1F1F';
      case 'CREATED':
        return '#E8AA26';
      case 'WAITING_APPROVAL':
        return '#E8AA26';
      case 'CANCELLED_BY_ADMIN':
        return '#DC1F1F';
      case 'CANCELLED_BY_USER':
        return '#DC1F1F';
      case 'FAILED':
        return '#DC1F1F';
      case 'INITIATED':
        return '#1DA316';
      case 'APPROVED':
        return '#1DA316';
      default:
        return '#304497'; 
    }
  };